import { memo } from 'react';
import './ContentWrapper.css';

const ContentWrapper = ({
	children,
	isFixed,
	contentWrapperRef,
	top,
	position,
	padding,
	backgroundColor,
	backgroundImage,
	backgroundImagePosition,
	backgroundSize,
	color,
	...rest
}) => {
	return (
		<div
			className="ContentWrapper"
			data-testid="ContentWrapperTestId"
			style={{
				backgroundColor: backgroundColor !== undefined ? backgroundColor : '#f7f9fc',
				backgroundImage: backgroundImage !== undefined ? `url(${backgroundImage})` : 'none',
				backgroundPosition: backgroundImagePosition,
				backgroundRepeat: 'no-repeat',
				backgroundSize: backgroundSize || 'cover',
				bottom: isFixed === true ? '0' : 'auto',
				color,
				overflowY: isFixed === true ? 'hidden' : 'auto',
				padding,
				position,
				top
			}}
			{...rest}
			ref={contentWrapperRef}
		>
			{children}
		</div>
	);
};

ContentWrapper.defaultProps = {
	ref: null
};

export default memo(ContentWrapper);
